import React from "react";
import { Card, List, Avatar, Button } from "antd";
import { UserOutlined } from "@ant-design/icons";
import Index from "./pages/Index.tsx";

const Settings = ({ photo_profil }) => {
  return (
    <>
     <Index/>
    </>
  
  );
};

export default Settings;
